import React from 'react';
import PropTypes from 'prop-types';
import FlatButton from 'material-ui/FlatButton';
import PaginationAmount from 'components/list/Pagination/PaginationAmount';
import paginationHelper from 'helpers/pagination';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { ChevronLeftIcon, ChevronRightIcon } from 'assets/materialIcons/materialIcons';
import { Toolbar, ToolbarGroup } from 'material-ui/Toolbar';

const styles = {
    button: {
        margin: '10px 0',
    },
};

class Pagination extends React.Component {
    componentDidMount() {
        const { currentPage, setPage } = this.props;

        setPage(currentPage);
    }

    getTotalPages() {
        const { size, total } = this.props;

        return Math.ceil(total / size) || 1;
    }

    handleClick = (newPage, event) => {
        event.preventDefault();

        const { setPage, translate } = this.props;

        if (newPage < 1 || newPage > this.getTotalPages()) {
            throw new Error(translate('aor.navigation.page_out_of_boundaries', {
                page: newPage,
            }));
        }

        setPage(newPage);
    }

    handlePrevPage = (event) => {
        event.preventDefault();

        const { currentPage, setPage, translate } = this.props;

        if (currentPage === 1) {
            throw new Error(translate('aor.navigation.page_out_from_begin'));
        }

        setPage(currentPage - 1);
    }

    handleNextPage = (event) => {
        event.preventDefault();

        const { currentPage, setPage, translate } = this.props;

        if (currentPage > this.getTotalPages()) {
            throw new Error(translate('aor.navigation.page_out_from_end'));
        }

        setPage(currentPage + 1);
    }

    fetchPageNumbers = () => {
        const { basePageNumber, minAmount, steps, currentPage } = this.props;

        const totalPages = this.getTotalPages();

        let from = basePageNumber;
        let to = totalPages;

        if (totalPages > minAmount) {
            from = Math.max(currentPage - steps, 1);
            to = Math.min(currentPage + steps, totalPages);
        }

        let range = [];

        // Create an array of pages
        for (let i = from; i <= to; i++) {
            range.push(i);
        }

        if (totalPages <= minAmount) {
            return range;
        }

        const firstPage = range[0];

        // If the firstPage is more then the basePageNumber.
        if (firstPage > basePageNumber) {
            if (firstPage > 2) {
                range.unshift('.');
            }

            range.unshift(1);
        }

        const lastPage = range[range.length - 1];

        // If the lastPage is less then the totalpages.
        if (lastPage < totalPages) {
            // If there is a gap between the lastPage and the amount of totalPages we will add a dot.
            if (lastPage < totalPages - 1) {
                range.push('.');
            }

            range.push(totalPages);
        }

        return range;
    }

    render() {
        if (!this.props.total === 0) {
            return null;
        }

        const {
            basePageNumber,
            currentPage,
            minAmount,
            size,
            total,
        } = this.props;

        const offsetEnd = Math.min(currentPage * size, total);
        const offsetBegin = paginationHelper.generateNewOffset(currentPage, size) + 1;
        const totalPages = this.getTotalPages();

        return (
            <Toolbar>
                <PaginationAmount
                    offsetBegin={ offsetBegin }
                    offsetEnd={ offsetEnd }
                    total={ total }
                />

                { totalPages > basePageNumber &&
                    <ToolbarGroup>
                        { totalPages > minAmount && currentPage > basePageNumber &&
                            <FlatButton
                                className='previous-page'
                                icon={ <ChevronLeftIcon /> }
                                key='prev'
                                onClick={ this.handlePrevPage }
                                primary
                                style={ styles.button }
                            />
                        }

                        { this.fetchPageNumbers().map((pageNum, index) => {
                            return (
                                (pageNum === '.') ?
                                    <span
                                        key={ `hyphen_${ pageNum }_${ index }` } // eslint-disable-line
                                        style={ {
                                            padding: '1.2em',
                                            color: theme.palette.primary1Color,
                                        } }
                                    >&hellip;</span>
                                    :
                                    <FlatButton
                                        className={ `page-number ${ pageNum === currentPage ? 'page-number--active' : '' }` }
                                        disabled={ pageNum === currentPage }
                                        key={ `${ currentPage }_${ pageNum }` }
                                        label={ pageNum }
                                        onClick={ (event) => {
                                            return this.handleClick(pageNum, event);
                                        } }
                                        primary={ pageNum !== currentPage }
                                        style={ styles.button }
                                    />
                            );
                        }) }

                        { totalPages > minAmount && currentPage !== totalPages &&
                            <FlatButton
                                className='next-page'
                                key='next'
                                icon={ <ChevronRightIcon /> }
                                labelPosition='before'
                                onClick={ this.handleNextPage }
                                primary
                                style={ styles.button }
                            />
                        }
                    </ToolbarGroup>
                }
            </Toolbar>
        );
    }
}

Pagination.defaultProps = {
    minAmount: 4,
    steps: 1,
    basePageNumber: 1,
};

Pagination.propTypes = {
    basePageNumber: PropTypes.number,
    currentPage: PropTypes.number,
    minAmount: PropTypes.number,
    steps: PropTypes.number,
    setPage: PropTypes.func,
    size: PropTypes.number,
    total: PropTypes.number,
    translate: PropTypes.func.isRequired,
};

export default translate(Pagination);



// WEBPACK FOOTER //
// ./src/components/list/Pagination/Pagination.js